<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14.065" viewBox="0 0 20 14.065">
    <path class="a" d="M2,6A1,1,0,0,1,3,5H21a1,1,0,0,1,0,2H3A1,1,0,0,1,2,6Z" transform="translate(-2 -5)"/>
    <path class="a" d="M2,12.032a1,1,0,0,1,1-1H21a1,1,0,0,1,0,2H3A1,1,0,0,1,2,12.032Z" transform="translate(-2 -5)"/>
    <path class="a" d="M3,17.065a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z" transform="translate(-2 -5)"/>
  </svg>
</template>

<script>
export default {
  name: "HamburgerIconDark"
}
</script>

<style scoped>
.a {
  fill: #8ea2a8;
}
</style>
